import React, { useState } from "react";
import "./../assets/css/modal.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import bannerImage from "./../assets/banner/portada.jpg";
import imgVertical from "./../assets/banner/imgvertical.jpg";
import logvefase from "./../assets/banner/logo-negro.webp";
import { FaAccessibleIcon } from 'react-icons/fa';
import Banner from "../components/Banner";
import AccessibilityModal from './../components/AccessibilityModal';

const Noticias = () => {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
     <div className="micolor-jm">
        <Header />
      <button className="floating-button" onClick={toggleModal}>
      <img
               src={require("../assets/clientes/iconoaccesibilidad.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "50px",
                height:"50px",
              
              }}
            />
      </button>

      <AccessibilityModal isOpen={showModal} toggle={toggleModal} />
    
  
    
      <div className="container">
        <div className="row row-jm">
          
         
         <div className="col-md-6 col-sm-12 mt-5">
            <h2 className="mt-4 sobre-nosotras-title">ARTICULOS
            </h2>
          </div>
          <div className="col-md-12 col-sm-12 mt-5">
            
            
          </div>
          <div className="col-md-6 col-sm-12 mt-4 text-center">
            <img
               src={require("../assets/home/ata.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "100%",
              }}
            />
            <p className="mitexto text-left">
            Fecha : 12/05/2025
            </p>
            <p className="mitexto text-left"  style={{
                fontSize:15,
              }}>
                Autor: Habitat
            </p>
           <p className="mitexto text-left">
           <strong>Espacios de trabajo para todos: cómo la accesibilidad impulsa productividad, inclusión y bienestar.

           </strong>
           <br></br>
           Quería comenzar este artículo con datos técnicos y aclaraciones normativas, 
           pero luego pensé: a veces es más efectivo transmitir una idea a través de una experiencia real...

            </p>
            <div className="more-news-link">
                <a href="/espacio-de-trabajo-para-todos">
                <button className="contact-button">Ver noticias</button>
                </a>
              </div>
          </div>
         

          <div className="col-md-6 col-sm-12 mt-4 mb-5 text-center">
            <img
               src={require("../assets/home/ava.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "100%",
              }}
            />
             <p className="mitexto text-left">
           Fecha : 12/05/2025
            </p>
            <p className="mitexto text-left" style={{
                fontSize:15,
              }}>
                Autor: Habitat
            </p>
           <p className="mitexto text-left">
           <strong>Hogar accesible, vida autónoma: la clave de viviendas inclusivas para personas mayores y con discapacidad

           </strong>
           <br></br>
           Diseñar viviendas accesibles no solo mejora la autonomía y calidad de vida de personas con discapacidad o adultos mayores, sino 
           que también previene accidentes...

            </p>
            <div className="more-news-link">
                <a href="/hogar-accesible-vida-automata">
                <button className="contact-button">Ver noticias</button>
                </a>
              </div>
          </div>
          
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Noticias;